export enum CrossSellCompany {
    Lexington,
    Self,
    WalmartMoneyCard,
    CreditScoreIQ,
    Finsie,
    PersonalLoan,
    CreditCards,
    PersonalLoans,
    Payday,
    SurveyCashDeals,
}